//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Faqs',
  props: {
    faqs: {
      type: Array,
      default: () => []
    }
  }
};
